import { combineReducers } from 'redux';
import essentialsReducer from './essentials/essentials.reducer';
import proReducer from './pro/pro.reducer';

export default combineReducers({
  essentials: essentialsReducer,
  pro: proReducer
});
